/**
 * Intervals orders resources by display name (`Electricity`, then `Natural Gas`).
 * Site bills store type codes (`electricity`, `natural_gas`). This is that same
 * order, written as the type code, with electricity first when the site has it.
 */
const BILL_RESOURCE_ORDER = [
  "electricity",
  "natural_gas",
  "fuel",
  "water",
  "refrigerant",
] as const

const resourceRank = (code: string): number => {
  const index = BILL_RESOURCE_ORDER.indexOf(
    code as (typeof BILL_RESOURCE_ORDER)[number]
  )
  return index === -1 ? BILL_RESOURCE_ORDER.length : index
}

export const orderBillResourceCodes = (codes: readonly string[]): string[] =>
  [...codes].sort(
    (left, right) =>
      resourceRank(left) - resourceRank(right) || left.localeCompare(right)
  )

export const defaultBillResourceCode = (
  codes: readonly string[]
): string | null => {
  if (codes.includes("electricity")) {
    return "electricity"
  }

  return orderBillResourceCodes(codes)[0] ?? null
}
